// START IMPORTS
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { Box } from '@ltvco/refresh-lib/theme';
import { Header } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useEffect } from 'react';
// END IMPORTS

// START INTERFACES_AND_TYPES
type HeaderParentProps = {
  handleSearchSuccess: any;
  // eslint-disable-next-line no-unused-vars
  changeSingleReportVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeOwnerSearchVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeIsInAstrologyStandaloneVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeIsInPerksPageVariation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeInternationalLanguageTest: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeInternationalVinTest: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeListV2Variation: (variation: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  changeCourtCasesVariation: (variation: boolean) => void;
};
// END INTERFACES_AND_TYPES

export const HeaderParent = ({
  handleSearchSuccess,
  changeSingleReportVariation,
  changeIsInAstrologyStandaloneVariation,
  changeIsInPerksPageVariation,
  changeInternationalLanguageTest,
  changeInternationalVinTest,
  changeListV2Variation,
  changeCourtCasesVariation,
}: HeaderParentProps) => {
  const isInAstrologyStandaloneVariation = useFeatureIsOn('oar-1164');
  const isInListV2Variation = useFeatureIsOn('prop-2834');
  const isInCourtCasesVariation = useFeatureIsOn('court-case-search');
  const isInPerksPageVariation = useFeatureIsOn('RFRSH-3131');

  const {
    singleReportVariation,
    internationalLanguageVariation,
    vinVariation,
  } = useSubscriptionAccessConfigContext();
  // END HOOKS_AND_QUERIES

  // START EFFECTS
  useEffect(() => {
    changeSingleReportVariation(singleReportVariation);
  }, [singleReportVariation]);

  useEffect(() => {
    changeIsInAstrologyStandaloneVariation(isInAstrologyStandaloneVariation);
  }, [isInAstrologyStandaloneVariation]);

  useEffect(() => {
    changeIsInPerksPageVariation(isInPerksPageVariation);
  }, [isInPerksPageVariation]);

  useEffect(() => {
    changeInternationalLanguageTest(internationalLanguageVariation);
  }, [internationalLanguageVariation]);

  useEffect(() => {
    changeInternationalVinTest(vinVariation);
  }, [vinVariation]);

  useEffect(() => {
    changeListV2Variation(isInListV2Variation);
  }, [isInListV2Variation]);

  useEffect(() => {
    changeCourtCasesVariation(isInCourtCasesVariation);
  }, [isInCourtCasesVariation]);

  if (location.pathname.includes('/chatbv')) {
    return null;
  }
  // END EARLY_RETURNS

  // START RENDER
  return (
    <Box>
      <Header onSearchSuccess={handleSearchSuccess} />
    </Box>
  );
  // END RENDER
};
